import { Dispatch } from 'redux';

import lessonActions from 'common.components/lesson/actions';
import * as lessonSelectors from 'common.components/lesson/selectors';
import { prepLessonsActions } from 'store/prep-lessons/actions';
import { toggleModal } from './common';

export function deleteCLessonAsync(args: { cLessonId: number }) {
    return async function (dispatch: Dispatch<any>, getState: () => any) {
        const { cLessonId } = args;

        if (!cLessonId) {
            return;
        }

        const isDraft = !lessonSelectors.getLessonAssignmentDate(getState());
        await new Promise<void>((resolve, reject) =>
            dispatch(
                lessonActions.deleteCLesson({
                    cLessonId,
                    onSuccess: () => resolve(),
                    onError: () => reject(),
                    isDraft,
                })
            )
        );

        dispatch(toggleModal(false));
        dispatch(lessonActions.clearEditor());
        lessonActions.showLessonDeletedToast({ cLessonId, isDraft })(dispatch);
        dispatch(prepLessonsActions.clearPrepLessonsDetails());
    };
}
